import { useEffect, useState } from 'react';

import { useGraphqlApiHeaders } from 'business/contextProviders/useApiHeaders';
import { Module_Enum, useGetImportTaskQuery } from 'generated/graphql';

export interface GlobalWarning {
  type: 'global';
  label: string;
  values?: string[];
}

export interface LinesWarning {
  type: 'lines';
  label: string;
  values: { line: number; label: string }[];
}

export type Warning = GlobalWarning | LinesWarning;

interface Task {
  warnings?: Warning;
}

export const useImportTaskData = (id: string) => {
  const [task, setTask] = useState<Task | undefined>(undefined);

  const gqlHeaders = useGraphqlApiHeaders(Module_Enum.QualityScan);
  const { data } = useGetImportTaskQuery({
    variables: {
      id,
    },
    context: {
      headers: gqlHeaders,
    },
  });

  useEffect(() => {
    if (data?.task) {
      setTask(data.task.length > 0 ? data.task[0] : undefined);
    }
  }, [data]);

  return {
    task,
  };
};
